/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Split_Multiview_FailedInputs */

const en_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to split multiview group: ${i?.error}`)
};

const fr_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la division du groupe multivue : ${i?.error}`)
};

const de_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Aufteilen der Multiview-Gruppe: ${i?.error}`)
};

const it_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile suddividere il gruppo multivista: ${i?.error}`)
};

const ru_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось разделить группу с несколькими представлениями: ${i?.error}`)
};

const es_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al dividir el grupo multivista: ${i?.error}`)
};

const zh_cn2_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`拆分多视图组失败：${i?.error}`)
};

const ja_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マルチビューグループの分割に失敗しました: ${i?.error}`)
};

const hi_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मल्टीव्यू समूह को विभाजित करने में विफल: ${i?.error}`)
};

const pt_pt2_split_multiview_failed = /** @type {(inputs: Split_Multiview_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao dividir o grupo de visualização múltipla: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to split multiview group: {error}" |
*
* @param {Split_Multiview_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_failed = /** @type {((inputs: Split_Multiview_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_split_multiview_failed(inputs)
	if (locale === "de") return de_split_multiview_failed(inputs)
	if (locale === "it") return it_split_multiview_failed(inputs)
	if (locale === "ru") return ru_split_multiview_failed(inputs)
	if (locale === "es") return es_split_multiview_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_split_multiview_failed(inputs)
	if (locale === "ja") return ja_split_multiview_failed(inputs)
	if (locale === "hi") return hi_split_multiview_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_split_multiview_failed(inputs)
	return en_split_multiview_failed(inputs)
});